module.exports = __webpack_public_path__ + "static/media/sh.e9df1d75.svg";